module.exports = __webpack_public_path__ + "img/flow.f99c77f8.png";